export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#3A1A10',
    light: '#ebe8e7',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#43C2BD',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#272727',
    secondary: '#23262F',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow:'#292D32'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: 'rgba(229, 251, 254, 0.8)',
    footer: '#F9F9F5',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#43C2BD',
    tableHead: '#073745',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#18CACF',
    secondary: 'rgb(240,243,243)',
    light: '#ebe8e7',
    arrow: '#3A1A10',
    secondaryLight: '#F9F9F5'
  },
  verticalBar: {
    used: '#3A1A10',
    unused: '#ebe8e7',
    unlimited: '#C0C0C0',
  }
};